import { CircularProgress } from '@mui/material';
import PolicyHolderQuotePolicy100Coverages from './PolicyHolderQuotePolicyP100Coverages';
import { useP100RaterVersionFallback } from '../../workflows/quotes/prime-100/hooks/useP100RaterVersionFallback';
import { ProductTypes } from '../../../types';

/** P100 coverages table; waits on linked-quote rater version when policy has none. */
export function P100CoveragesFromPolicy({
  policy,
  product,
}: Readonly<{ policy: any; product: string }>) {
  const rater = useP100RaterVersionFallback(
    product === ProductTypes.p100 ? policy : null
  );

  if (product !== ProductTypes.p100 || !policy?.coverages) {
    return null;
  }

  if (rater.isLoading) {
    return <CircularProgress size={24} />;
  }

  return (
    <PolicyHolderQuotePolicy100Coverages
      coverages={policy.coverages}
      boostVersion={rater.version}
    />
  );
}
